// extracted by mini-css-extract-plugin
export default {"container":"blog_container__xaw56","title":"blog_title__Az62V","cardContainer":"blog_cardContainer__f8fkQ"};